"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Money = void 0;
const InvalidCurrency_1 = __importDefault(require("../../../Errors/InvalidCurrency"));
class Money {
    constructor(value) {
        this.value = value;
        if (!Number.isInteger(value)) {
            throw new InvalidCurrency_1.default(`Expected a number, got (${typeof value}) from (${value})`, 400);
        }
    }
}
exports.Money = Money;
exports.default = Money;
